/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brand_MarkInputs */

const en_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand Mark`)
};

const es_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca de marca (Logo)`)
};

const fr_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo de la marque`)
};

const de_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markenzeichen (Logo)`)
};

const ja_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブランドマーク`)
};

const zh_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品牌徽标`)
};

const ar_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`علامة العلامة التجارية (الشعار)`)
};

const id_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merek Logo`)
};

const it_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marchio del Brand`)
};

const ru_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип бренда`)
};

const pt_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca da Empresa`)
};

const ko_brand_mark = /** @type {(inputs: Brand_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브랜드 마크 (로고)`)
};

/**
* | output |
* | --- |
* | "Brand Mark" |
*
* @param {Brand_MarkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const brand_mark = /** @type {((inputs?: Brand_MarkInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brand_MarkInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_brand_mark(inputs)
	if (locale === "es") return es_brand_mark(inputs)
	if (locale === "fr") return fr_brand_mark(inputs)
	if (locale === "de") return de_brand_mark(inputs)
	if (locale === "ja") return ja_brand_mark(inputs)
	if (locale === "zh") return zh_brand_mark(inputs)
	if (locale === "ar") return ar_brand_mark(inputs)
	if (locale === "id") return id_brand_mark(inputs)
	if (locale === "it") return it_brand_mark(inputs)
	if (locale === "ru") return ru_brand_mark(inputs)
	if (locale === "pt") return pt_brand_mark(inputs)
	return ko_brand_mark(inputs)
});